import { defineComponent as _defineComponent } from 'vue'
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import {
  Heading,
  Row,
  InitialAvatarIcon,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { Ref, computed, inject, ref } from 'vue';
import { GoalType } from '@/types/models/Portfolio';

import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutLinks',
  props: {
    isPrivatePension: { type: Boolean }
  },
  emits: ['openDelete', 'openRename', 'openChangeBackground'],
  setup(__props: any, { emit }) {

const props = __props as {
  isPrivatePension: boolean;
}

const router = useRouter();



const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;
const reloadCause = inject('reloadCause') as Ref<string>;
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  inject<IPortfolioDistributionResponse>('portfolioDistribution')
);

function routeToWalletBuilderEdit() {
  router.push({
    name: 'wealthBuilderViewEdit',
    params: { portfolioId: portfolioDistribution?.value?.portfolio?.id }
  });
}

const portfolioName = computed(() => {
  if (
    isPortfolioDistributionLoading.value === true &&
    reloadCause.value === 'renamePortfolio'
  )
    return 'Carregando...';

  return portfolioDistribution.value?.portfolio?.name ?? '';
});

const isPrivatePension = computed(() => {
  return (
    portfolioDistribution.value?.portfolio?.goal === GoalType.PRIVATE_PENSION
  );
});

const showDeletePortfolio = computed(() => {
  return (
    !portfolioDistribution?.value?.portfolio?.shouldShowFeesMessage &&
    !isPrivatePension.value
  );
});

const isAllowedToEditPortfolio = computed(() => {
  return (
    portfolioDistribution?.value?.portfolio?.isCustom && !props.isPrivatePension
  );
});

return { __sfc: true,router, emit, props, isPortfolioDistributionLoading, reloadCause, portfolioDistribution, routeToWalletBuilderEdit, portfolioName, isPrivatePension, showDeletePortfolio, isAllowedToEditPortfolio, Heading, Row, InitialAvatarIcon, SkeletonLoader }
}

})